import {LocaleDictionaryAuth} from "../../interface/auth";

export const auth: LocaleDictionaryAuth = {
    authText1: 'We have switched to a new authorization system',
    authText2: 'The RUDN ID passport is a single account for easy and secure login to the mobile application and to the RUDN web services',
    authText3: 'If you have a RUDN corporate email, use it to log in',
    continue: 'Continue',
    askForAccount: 'Already have a RUDN account?',
    dontHaveAccount: `Don't have RUDN account?`,
    logInAccount: 'Login',
    loginTitle: 'E-mail/phone number',
    phoneTitle: 'Email or phone number',
    enterPhone: 'Enter phone',
    enterPhoneText: 'Ваш номер телефона будет использоваться для входа в аккаунт',
    loginPlaceholder: 'Enter phone/E-mail',
    phonePlaceholder: 'Enter phone number',
    passwordPlaceholder: 'Password',
    password: 'Password',
    passwordsDontMatch: `Passwords don't match`,
    forgotPassword: 'Forgot password?',
    logIn: 'Sign in',
    register: 'Register',
    registration: 'Registration',
    createAccount: 'Create account in RUDN ID ',
    accountNotFound: 'Passport not found. Create new RUDN ID',
    passwordRecovery: 'Password recovery',
    enterLoginForRecovery: 'Введите email или номер телефона, которые вы указывали в регистрации',
    enterPhoneForRecovery: 'Enter your registration email or phone number',
    checkRecoveryAccount: 'Please select the required account:',
    mailSent: 'ChangePhone mail sent',
    mailSentText: 'Мы отправили письмо с ссылкой для восстановления пароля по адресу ',
    enterSMSCode: 'Введите код, отправленный на номер ',
    enterCode: 'Confirm your phone',
    enterMailCode: 'Enter the code sent to your email',
    confirmCode: 'Confirm code',
    smsCode: 'SMS code',
    retryCode: 'Get new code',
    recoveryByEmail: 'Confirmation code is send to email',
    recoveryByPhone: 'Enter the sms code sent to',
    retrySMSAfter: 'Receive SMS via ',
    SMSSent: 'Отправили SMS c кодом подтверждения на номер ',
    noAccess: 'Нет доступа к почте и телефону',
    IDontHaveAccess: 'У меня нет доступа к этим данным',
    accountHelp1: 'Напишите, пожалуйста, в поддержку на почту',
    accountHelp2: ' support@rudn.ru ',
    accountHelp3: ' или ',
    accountHelp4: 'зарегистрируйтесь в системе заново',
    numberConflict: 'Ваш номер привязан к другому аккаунту',
    numberConflictText1: 'Напишите, пожалуйста, в поддержку на почту',
    numberConflictText2: `, укажите свой номер в международном формате и прикрепите к письму справку,
     кому принадлежит номер, или договор на этот номер телефона (копию договора и справку можно получить в офисе мобильного оператора).
      На снимке должны быть: номер, дата заключения договора, печать и подпись представителя оператора связи.`,
    itIsYou: 'Is it you?',
    thisIsMe: 'Yes, it is me',
    itsNotMe: `No, it's not me`,
    email: 'E-mail',
    enterMail: 'Enter E-mail',
    enterMailText: 'Если вы забудете пароль, то сможете легко восстановить доступ к аккаунту с помощью электронной почты',
    noAccessToMail: 'No access to mail',
    mailCodeSent: 'Отправили письмо c кодом подтверждения на почту ',
    newCodeSent: 'New code sent',
    retryCodeAfter: 'Receiving the code via ',
    success: 'Success!',
    successText: 'Вы успешно подтвердили аккаунт РУДН ID. Теперь вам доступны все сервисы Университета',
    goToPlatform: 'Go to platform',
    chooseCreateType: 'Выберите способ создания аккаунта в РУДН ID',
    fromStateServices: 'Через ЕСИА',
    fromPersonalData: 'Заполнение  личных данных',
    name: 'Name',
    surname: 'Surname',
    middleName: 'Middle name',
    birthDate: 'Birth date',
    studentCard: 'Номер студенческого билета (при наличии)',
    addStudentCard: 'Добавить еще один студенческий билет',
    groups: 'Группа/ группы (при наличии)',
    personalNumber: 'Табельный номер (при наличии)',
    addPersonalNumber: 'Добавить еще один табельный номер',
    passwordRules: 'Password must be of minimum 9 characters, including numbers, letters in different cases and special characters',
    repeatPassword: 'Repeat password',
    createPassword: 'Придумайте пароль для входа в РУДН ID',
    change: ' Change',
    loginHint: 'Login can be: Corporate mail in the domain @rudn.ru, @pfur.ru, personal E-mail, mobile phone',
    loginCanBe: 'Login can be: ',
    corporateMail: 'Corporate mail in the domain @rudn.ru, @pfur.ru',
    electronicMail: 'Personal  E-mail',
    mobilePhone: 'Phone number',
    passport: 'Passport',
    snils: 'Insurance Number',
    inn: 'Individual Taxpayer Number',
    citizenship: 'Citizenship',
    ruPassport: 'Passport of the Russian Federation',
    foreignIdentityCard: 'Foreign identity card',
    series: 'Series',
    number: 'Number',
    enterValidPhone: 'Enter valid phone number',
    nothingFound: 'Nothing found',
    sendVerificationCode: 'Confirm email',
    submit: 'Submit',
    identityCard: 'Identity card',
    documentNumber: 'Document number',
    cancel: 'Cancel',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    phonesDontMatch: `Phone numbers do not match`,
    phoneSetSuccessful: 'Номер телефона успешно изменен',
    emailSetSuccessful: 'Электронная почта успешно изменена',
    finish: 'Завершить',
    pageNotFound: 'Page not found',
    returnToPassport: 'Return to RUDN ID',
    passwordSaveSuccess: 'Password saved',
    needResetPassword: 'Password reset required',

    smsSend: 'SMS sent to',
    codeSend: 'Code sent to email',
    enterFromSms:'Enter the code from SMS',
    verifiPhoneNumber: 'Confirm phone number',
    accountBind: 'Link account',
    confirmOperationEnterPassword: 'To confirm the operation, enter the password for the account with this account.',
    selectPrimaryDomain: 'Select the primary account domain to associate with this account.',
    bind: 'Link',
    skipAndGoToProfile: 'Skip and go to profile',
    accountsBinding: 'Your accounts are binded!',
    attention: 'Attention',
    importedAccountsMessage: 'When you link accounts, data will be imported from the linked account',
    emailEnter: 'Email',
    LoginUnderUserAccount: 'Login under user account',
    selectAccountsMessage: 'You can change the account under which you want to log in to your Personal Account. To do this, select the desired account from the list below:',
    save: 'Save',
    sendAgainIn: 'Send again in',
    passwordExpiryWarning: {
        title: 'Password expiration warning',
        today: 'Your password expires today. After expiration, you will not be able to sign in.',
        tomorrow: 'Your password expires tomorrow. After expiration, you will not be able to sign in.',
        daysLeft: 'Your password expires in {{days}} days. After expiration, you will not be able to sign in.',
        recommendation: 'We recommend changing your password now to avoid access issues.',
        skip: 'Skip',
        changePassword: 'Change password'
    }
}
